import { Component, h, Prop } from "@stencil/core"
import closeButtonImg from "./closeButtonImg.svg"

/**
 * This component contains a close button used in Payair SRCi SDK.
 */
@Component({
  tag: "close-button",
  styleUrl: "CloseButton.scss",
})
export class CloseButton {
  /**
   * Callback called after close button click.
   */
  @Prop() closeButtonOnClick?: () => void

  render() {
    return <img class="closeButton" src={closeButtonImg} onClick={this.closeButtonOnClick} />
  }
}
